import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { Home } from './pages/Home'
import { Hotels } from './pages/Hotels'
import { History } from './pages/History'
import { Account } from './pages/Account'
import { Login } from './pages/Login'
import { Register } from './pages/Register'
import { Verify } from './pages/Verify'
import { AuthVerify } from './pages/AuthVerify'
import { Nav } from './components/Nav'
import './App.css'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  
  if (loading) return <div className="loading">Loading...</div>
  if (!user) return <Navigate to="/login" />
  
  return <>{children}</>
}

function AppRoutes() {
  const { user } = useAuth()
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/auth/verify" element={<AuthVerify />} />
      <Route path="/register" element={
        <ProtectedRoute>
          <Register />
        </ProtectedRoute>
      } />
      <Route path="/" element={
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      } />
      <Route path="/hotels" element={
        <ProtectedRoute>
          <Hotels />
        </ProtectedRoute>
      } />
      <Route path="/history" element={
        <ProtectedRoute>
          <History />
        </ProtectedRoute>
      } />
      <Route path="/account" element={
        <ProtectedRoute>
          <Account />
        </ProtectedRoute>
      } />
      <Route path="/verify" element={
        <ProtectedRoute>
          <Verify />
        </ProtectedRoute>
      } />
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="app">
          <AppRoutes />
          <Nav />
        </div>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
